<div class="food-order-card-container" [ngClass]="{ 'last-card': isLast }" *ngIf="food">
    <div class="food-order-card">
        <div class="food-order-info" [ngClass]="{'strikethrough': foodOrder?.status == 'Cancelled'}">
            <p class="food-order-title">{{ food | fieldTranslate: 'title' }}
                <span *ngIf="food.count > 1">({{ food.count }}  {{ locale?.units?.get(unit) }})</span>
            </p>

            <!-- модификаторы -->
            <div class="food-order-modificators" *ngIf="modificators?.items?.length">
                <div class="food-order-modificator">
                    <div *ngFor="let item of modificators?.items">
                        <div *ngIf="item.count > 0 && item.price as value">
                            <span>{{ item.count }} · {{ item | titleTranslate }} ·</span>
                            <ng-container *ngIf="item.count * item.price | priceSeparator as separated">
                                <span class="food-order-modificator__whole" >{{ separated.whole }}</span>
                                <span class="food-order-modificator__dot">{{ separated.separator }}</span>
                                <span class="food-order-modificator__fraction">{{ separated.fraction }}</span>
                                <span class="food-order-modificator__currency">{{ locale?.currency }}</span>
                              </ng-container>
                        </div>
                    </div>
                </div>
            </div>

            <p class="food-order-price" *ngIf="food.price as value">
                <!-- <span style="margin: 0 3px; font-size: 14px">x</span> -->
                <ng-container *ngIf="value | priceSeparator as separated">
                    <span *ngIf="food.count > 1" class="food-order-price__count">{{ food.count }} x </span>
                    <span class="food-order-price__whole">{{ separated.whole }}</span>
                    <span class="food-order-price__dot">{{ separated.separator }}</span>
                    <span class="food-order-price__fraction">{{ separated.fraction }}</span>
                    <span class="food-order-price__currency">{{ locale?.currency }}</span>
                </ng-container>
                <span class="food-order-variant" *ngIf="food.variability">{{ food.variants[food.choise].title }}</span>
                <span class="food-order-size" *ngIf="food.size">{{ localSize }} {{ locale?.units?.get(food.unit) }}</span>
            </p>
            <!-- Аллергены: свои и выбранных добавок -->
            <app-allergen-pill class="allergen-row" [plain]="true" [max]="14"
              [allergens]="food.allergens | allergensWithAddons: modificators"></app-allergen-pill>
        </div>
        <div class="food-order-image" *ngIf="food.image">
            <img [src]="imageSrc" alt="{{ food | fieldTranslate: 'title' }}" [ngClass]="{'grayscale': foodOrder && foodOrder.status === 'Cancelled'}"/>
        </div>
    </div>
</div>